<div class="d-flex justify-content-between">
    <!--Edit Item tooltip="Edit {{item_name}}" -->
    <button
      type="button"
      class="btn btn-outline-warning btn-sm ag_grid_row_btn form-control py-0"
      placement="right"
      (click)="editItemClick()"
    >
    <i class="fa-solid fa-pen"></i>
    </button>
  
    <!--Delete Item  tooltip="Delete {{item_name}}" -->
    <button
      type="button"
      class="btn btn-outline-danger btn-sm ag_grid_row_btn form-control py-0"
      style="margin-left: 2px; margin-right: 2px"
      placement="right"
      (click)="deleteItemClick()"
    >
    <i class="fa-solid fa-trash-can"></i> 
    </button>
  </div>
  